import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import Styled from './DragDrop.styled';
import { ResumoRecursoCustomizado } from 'models/recursos-costumizados/ResumoRecursoCustomizado';

export interface IAdminGestaoPaginasRecursosItem {
    secao: ResumoRecursoCustomizado;
}

export interface IAdminGestaoPaginasRecursosDropzone {
    onDropItem: (item: ResumoRecursoCustomizado, neworder: number) => void;
    thisOrder: number;
}

const typeItem = 'ADMIN-SECTION-ITEM';

export const AdminGestaoPaginasRecursosDragDrop = ({ children, secao }: React.PropsWithChildren<IAdminGestaoPaginasRecursosItem>) => {
    const [{ opacity }, dragRef] = useDrag(
        () => ({
            type: typeItem,
            item: secao,
            collect: monitor => ({
                opacity: monitor.isDragging() ? 0.3 : 1,
            }),
        }),
        []
    );

    return (
        <Styled.ListItem ref={dragRef} style={{ opacity }}>
            {children}
        </Styled.ListItem>
    );
};

/* eslint-disable react/prop-types */
export const AdminGestaoPaginasRecursosDropzone = ({ onDropItem, thisOrder }: IAdminGestaoPaginasRecursosDropzone) => {
    const [props, dropRef] = useDrop(() => ({
        accept: typeItem,
        collect: monitor => {
            const item = monitor.getItem<ResumoRecursoCustomizado>();

            return {
                ishover: monitor.isOver() && item.ordem != thisOrder && item.ordem + 1 != thisOrder,
            };
        },
        drop: (item: any, _) => {
            let neworder = thisOrder;

            if (item.ordem < neworder) neworder -= 1;

            if (item.ordem != neworder) onDropItem(item, neworder);
        },
    }));

    return <Styled.Dropzone ref={dropRef} isHover={props?.ishover ?? false} />;
};
